<template>
    <v-container fluid>
        <v-form ref="appuntamento" v-model="valid" lazy-validation id="formAppuntamento">
            <v-row>
                <v-col cols="12" class="text-left pb-0">
                    <v-row>
                        <v-container fluid class="pb-0">
                            <span class="pink title text-uppercase py-1 px-2">i tuoi dati</span>
                            <v-row>
                                <v-col cols="12">
                                    <p class="caption text-lowercase">*campi obbligatori</p>
                                </v-col>
                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="12" md="6" id="name">
                                            <v-text-field v-model="name" label="Nome*" :rules="inputRules"
                                                          ref="field1"
                                                          v-scroll-to="'#name'"
                                                          id="firstNameInput"
                                                          required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="lastName">
                                            <v-text-field v-model="lastName" label="Cognome*"
                                                          ref="field2"
                                                          :rules="inputRules"
                                                          id="lastNameInput"
                                                          v-scroll-to="'#lastName'"
                                                          required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="telephone">
                                            <v-text-field v-model="telephone" label="Telefono*"
                                                          ref="field3"
                                                          v-scroll-to="'#telephone'"
                                                          type="tel"
                                                          id="phoneInput"
                                                          :rules="telephoneRules" required>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="email">
                                            <v-text-field v-model="email" label="E-mail*"
                                                          ref="field4"
                                                          v-scroll-to="'#email'"
                                                          id="emailInput"
                                                          :rules="emailRules" required>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" id="code">
                                            <v-text-field v-model="cap" label="Cap*"
                                                          ref="field5"
                                                          id="capInput"
                                                          v-scroll-to="'#cap'"
                                                          :rules="capRules" required>
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="pt-5">
                                            <a href="/docs/axa/privacy_2026.pdf" target="_blank" class="privacy__link pt-5">Informativa privacy</a>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "FormAppuntamento",
        components: {},
        computed: {
            ...mapGetters({
                'getInsuredData': 'params/getInsuredData',
            }),
        },
        watch: {},
        data: () => ({
            valid: false,
            inputRules: [
                v => !!v || 'Campo obbligatorio',
            ],
            name: '',
            lastName: '',
            telephone: '',
            telephoneRules: [
                v => !!v || 'Campo obbligatorio',
                v => /(^\+\d{11,12}$)|(^00\d{11,12}$)|(^\d{9,10}$)/.test(v) || 'Il formato del numero di telefono non è corretto',
                //v => /^([a-zA-Z0-9_-]){3,5}$/g.test(v) || 'Il formato del numero di telefono non è corretto',
            ],
            cap: '',
            capRules: [
                v => !!v || 'Campo obbligatorio',
                v => /^\d{5}$/.test(v) || 'Il cap non è corretto',
            ],
            email: '',
            emailRules: [
                v => !!v || 'Campo obbligatorio',
                v => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(v) || 'E-mail non valida',
            ],
            consenso: 'no',
            // consensoRules: [
            //     v => !!v || 'Campo obbligatorio',
            // ],
            cont: 1,
            idSession: sessionStorage.getItem('sessionId'),
        }),
        mounted() {
            this.name = this.getInsuredData.name;
        },
        methods: {
            ...mapActions({
                'actionIsFormValidate': 'stickyBar/actionIsFormValidate',
                'actionIsDisable': 'stickyBar/actionIsDisable',
                'actionAppointmentDataAAI': 'params/actionAppointmentDataAAI',
            }),
        },
        updated() {
            if (this.name != '' && this.lastName != '' && this.telephone != '' && this.email != '' && this.cap != '' && this.consenso != '' && this.valid) {
                let data = {
                    name: this.name,
                    lastName: this.lastName,
                    telephone: this.telephone,
                    email: this.email,
                    cap: this.cap,
                    consenso: this.consenso,
                };
                this.actionAppointmentDataAAI(data);
                this.actionIsDisable(false);
                this.actionIsFormValidate(true);
            } else {
                this.actionIsDisable(true);
            }
        },
    };
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0;
    }
</style>
